module.exports = __webpack_public_path__ + "media/images/shared/app_store-a36347b0cde459ee20f220ea00e8270091fe0dc78a1ddf8eb0c46d24e17165ba.png";